export const labels = ["Jan 1st", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const optionsTimeSpan = [
    {value: "Last 7 days", text: "Last 7 days"},
    {value: "Last 14 days", text: "Last 14 days"},
    {value: "Last 28 days", text: "Last 28 days"},
    {value: "Last 60 days", text: "Last 60 days"},
    {value: "Last 90 days", text: "Last 90 days"},
    // {value: "Last 180 days", text: "Last 180 days"},
    // {value: "Last 365 days", text: "Last 365 days"}
];

export const persistent_menu = {
    "get_started":{
        "payload":"<GET_STARTED_PAYLOAD>"
    },
    "persistent_menu": [
        {
            "locale": "default",
            "composer_input_disabled": false,
            "call_to_actions": [

                {
                    "title": "⏳ As soon as published",
                    "type": "postback",
                    "payload": "Immediate (As soon as it’s published)"
                },
                {
                    "title": "⌛ Daily digest",
                    "type": "postback",
                    "payload": "Daily digest"
                },
                {
                    "title": "😬 See how it looks",
                    "type": "postback",
                    "payload": "I want to see how it looks first"
                },
                {
                    "type": "postback",
                    "title": "🔕 Unsubscribe",
                    "payload": "I want to unsubscribe"
                }
            ]
        }
    ]
};

export const persistent_menu_start_it = {
    "persistent_menu": [
        {
            "locale": "default",
            "composer_input_disabled": false,
            "call_to_actions": [
                {
                    "title": "⏰ Koliko često želite objave?",
                    "type": "nested",
                    "call_to_actions": [
                        {
                            "title": "⏳ Instant objave",
                            "type": "postback",
                            "payload": "Immediate (As soon as it’s published)"
                        },
                        {
                            "title": "⌛ Dnevna objava",
                            "type": "postback",
                            "payload": "Daily digest"
                        },
                        {
                            "title": "🤓 Vidi izgled objava?",
                            "type": "postback",
                            "payload": "I want to see how it looks first"
                        }
                    ]
                },
                {
                    "title": "🔕 Odjavi se!",
                    "type": "nested",
                    "call_to_actions": [
                        {
                            "title": "📵 Odjavi se!",
                            "payload": "I want to unsubscribe",
                            "type": "postback"
                        }
                    ]
                }
            ]
        },
        {
            "locale": "zh_CN",
            "composer_input_disabled": false
        }
    ]
};

export const persistent_menu_telegraf = {
    "persistent_menu":[
        {
            "locale":"default",
            "composer_input_disabled":false,
            "call_to_actions":[
                {
                    "title":"👇 Kada želite objave?",
                    "type":"nested",
                    "call_to_actions":[
                        {
                            "title":"⌚️ Odmah nakon objave",
                            "type":"postback",
                            "payload":"Immediate (As soon as it’s published)"
                        },
                        {
                            "title":"📺 Dnevni pregled",
                            "type":"postback",
                            "payload":"Daily digest"
                        },
                        {
                            "title": "📩 Vidi primer objava",
                            "type":"postback",
                            "payload":"I want to see how it looks first"
                        }
                    ]
                },
                {
                    "title":"🔕 Odjavi me!",
                    "type":"nested",
                    "call_to_actions":[
                        {
                            "title":"📵 Odjavi me!",
                            "payload":"I want to unsubscribe",
                            "type":"postback"
                        }
                    ]
                }
            ]
        },
        {
            "locale":"zh_CN",
            "composer_input_disabled":false
        }
    ]
};

export const teams_data = {
    teams: {
        data: [
            {
                team_name: "My team 1",
                id: "001",
                user_id: 23,
                admins: [
                    {
                        image: "/img/dicaprio.jpg",
                        email: "dicaprio@maill.com",
                        name: "Leo Man",
                        id: "15"
                    },
                    {
                        image: "/img/jon-snow.jpg",
                        email: "snow@maill.com",
                        name: "Jon Snow",
                        id: "22"
                    }
                ],
                pending_admins: [
                    {
                        email: "diiiiiicaprio@maill.com",
                        id: "155"
                    }
                ],
                feeds: [
                    {
                        subscribers: "555",
                        name: "Feed 001",
                        id: "444",
                        current_subscription: "Free Plan",
                        admins: [
                            {
                                image: "/img/dicaprio.jpg",
                                email: "dicaprio@maill.com",
                                name: "Leo Man",
                                id: "15"
                            },
                            {
                                image: "/img/jon-snow.jpg",
                                email: "snow@maill.com",
                                name: "Jon Snow",
                                id: "22"
                            }
                        ],
                        pending_admins: [
                            {
                                email: "diiiiiicaprio@maill.com",
                                id: "155"
                            },
                            {
                                email: "luuuuuumberjack@maill.com",
                                id: "444"
                            }
                        ]
                    },
                    {
                        subscribers: "666",
                        name: "Feed 005",
                        id: "553",
                        current_subscription: "Free Plan",
                        admins: [
                            {
                                image: "/img/dicaprio.jpg",
                                email: "dicaprio@maill.com",
                                name: "Leo Man",
                                id: "15"
                            },
                            {
                                image: "/img/jon-snow.jpg",
                                email: "snow@maill.com",
                                name: "Jon Snow",
                                id: "22"
                            },
                            {
                                image: "/img/lumberjack.jpg",
                                email: "lumberjack@maill.com",
                                name: "Lumberjack",
                                id: "44"
                            }
                        ]
                    }
                ]
            },
            {
                team_name: "My team 55",
                id: "006",
                user_id: 23,
                admins: [
                    {
                        image: "/img/dicaprio.jpg",
                        email: "dicaprio@maill.com",
                        name: "Leo Man",
                        id: "15"
                    }
                ],
                feeds: [
                    {
                        subscribers: "444",
                        name: "Feed 009",
                        id: "22",
                        current_subscription: "Free Plan",
                        admins: [
                            {
                                image: "/img/dicaprio.jpg",
                                email: "dicaprio@maill.com",
                                name: "Leo Man",
                                id: "15"
                            },
                            {
                                image: "/img/jon-snow.jpg",
                                email: "snow@maill.com",
                                name: "Jon Snow",
                                id: "22"
                            }
                        ]
                    },
                    {
                        subscribers: "333",
                        name: "Feed 008",
                        id: "24",
                        current_subscription: "Free Plan",
                        admins: [
                            {
                                image: "/img/dicaprio.jpg",
                                email: "dicaprio@maill.com",
                                name: "Leo Man",
                                id: "15"
                            },
                            {
                                image: "/img/lumberjack.jpg",
                                email: "lumberjack@maill.com",
                                name: "Lumberjack",
                                id: "44"
                            }
                        ]
                    }
                ]
            },
            {
                team_name: "My team 666",
                id: "008",
                admins: [
                    {
                        image: "/img/dicaprio.jpg",
                        email: "dicaprio@maill.com",
                        name: "Leo Man",
                        id: "15"
                    }
                ],
                feeds: []
            }
        ]
    },
    // feeds_shared: [
    //     {
    //         subscribers: "555",
    //         name: "Feed 001",
    //         id: "234",
    //         current_subscription: "Free Plan",
    //         admins: [
    //             {
    //                 image: "/img/dicaprio.jpg",
    //                 email: "dicaprio@maill.com",
    //                 name: "Leo Man",
    //                 id: "15"
    //             },
    //             {
    //                 image: "/img/jon-snow.jpg",
    //                 email: "snow@maill.com",
    //                 name: "Jon Snow",
    //                 id: "22"
    //             }
    //         ],
    //         pending_admins: [
    //             {
    //                 email: "diiiiiicaprio@maill.com",
    //                 id: "155"
    //             },
    //             {
    //                 email: "snooooooow@maill.com",
    //                 id: "222"
    //             }
    //         ],
    //         shared_by: {
    //             image: "/img/lumberjack.jpg",
    //             email: "lumberjack@maill.com",
    //             name: "Lumberjack",
    //             id: "44"
    //         }
    //     },
    //     {
    //         subscribers: "666",
    //         name: "Feed 005",
    //         id: "344",
    //         current_subscription: "Free Plan",
    //         admins: [
    //             {
    //                 image: "/img/dicaprio.jpg",
    //                 email: "dicaprio@maill.com",
    //                 name: "Leo Man",
    //                 id: "15"
    //             },
    //             {
    //                 image: "/img/jon-snow.jpg",
    //                 email: "snow@maill.com",
    //                 name: "Jon Snow",
    //                 id: "22"
    //             },
    //             {
    //                 image: "/img/lumberjack.jpg",
    //                 email: "lumberjack@maill.com",
    //                 name: "Lumberjack",
    //                 id: "44"
    //             }
    //         ],
    //         shared_by: {
    //             image: "/img/lumberjack.jpg",
    //             email: "lumberjack@maill.com",
    //             name: "Lumberjack",
    //             id: "44"
    //         }
    //     }
    // ]
};